var render = function render(){var _vm=this,_c=_vm._self._c;return _c('breakout-history-template',{attrs:{"treated-for-acne":_vm.treatedForAcne,"acne-treatments":_vm.acneTreatments,"gender":_vm.gender,"is-treated-for-acne":_vm.isTreatedForAcne,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }